export enum OperationType {
  Cabotage = 0,
  InternationalCarriage = 1,
}
